import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { faBookmark } from '@fortawesome/pro-regular-svg-icons';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { loginFromBookmarksTab } from '../../actions/list.actions';
import { ListItem, ListWithItemsCount } from '../../models/list';
import { BookmarkSearch } from '../searchable-bookmarks-search-bar/searchable-bookmarks-search-bar.component';
import { ListSearchService } from 'app/list/services/list-search.service';

@Component({
  selector: 'app-searchable-bookmarks-lists',
  templateUrl: './searchable-bookmarks-lists.component.html',
  styleUrls: ['./searchable-bookmarks-lists.component.scss']
})
export class SearchableBookmarksListsComponent implements OnInit, OnDestroy {
  @Input() public lists: ListWithItemsCount[];
  @Input() public authorized: boolean;
  @Input() public isStaffAuthorized: boolean;
  @Input() public count: number;
  @Input() public availableCount: number;
  @Output() public openList = new EventEmitter();
  @Output() public openAvailableList = new EventEmitter();
  public bookmarkIcon = faBookmark;
  public preview: ListItem[];


  // view data - search
  public listsSearch: ListWithItemsCount[] = [];
  public isSearch = false;
  public loading: boolean = false;
  public searchPreview: ListItem[] = [];
  public countSearch: number;
  public availableCountSearch: number;
  private readonly subscriptions: Subscription = new Subscription();

  constructor(
    private readonly store: Store,
    private readonly listSearchService: ListSearchService,
  ) {}

  ngOnInit() {
    this.preview = this.listSearchService.generateSearchPreview(this.lists.flatMap(l => l.items));
  }

  public ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  public logIn(event: Event): void {
    event.stopPropagation();
    this.store.dispatch(loginFromBookmarksTab());
  }

  public trackById(index: number, list: ListWithItemsCount): string {
    return list.id;
  }

  public onSearch(search: BookmarkSearch) {
    if (search.text || search.availableOnly) {
      this.isSearch = true;
    } else {
      this.isSearch = false;
      this.loading = false;
      return;
    }
    this.loading = true;
    this.listsSearch = [];
    this.listSearchService.searchAll(search).subscribe(({listsSearch, searchPreview, count, availableCount}) => {
      this.listsSearch = listsSearch;
      this.searchPreview = searchPreview;
      this.countSearch = count;
      this.availableCountSearch = availableCount;
      this.loading = false;
    });
  }
}
